import { AbstractPmsApiService } from './abstract.service'
import { DemoRequest } from '../models/demo-request.model';

/**
 * @class DemoRequestPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<DemoRequest>}
 */
export class DemoRequestPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/request-demo';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {DemoRequest}
     * @protected
     */
    newModel(attributes, ...params) {

        return new DemoRequest(attributes);
    }

    /**
     * @param {DemoRequest|Model} demoRequest
     * @param language
     * @returns {Promise.<Boolean>}
     */
    sendRequest(demoRequest, language = 'en') {

        const url = this.url();

        const payload = Object.assign(demoRequest.toObject(), {
            language: language
        });

        return this.http
            .post(url, payload, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/demo-request.service.js